// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"e1226e6a","226":"6e86ca55","228":"9ef7a210","277":"d7b8d7bc","479":"b7453bb3","981":"9e1038e7"}[chunkId] + ".chunk.js";
};